module.exports = __webpack_public_path__ + "static/软件产品证书-74a0c1d5b4dd07cfce025668ee13995f.jpg";